<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "~primevue/resources/themes/mdc-light-deeppurple/theme.css";
@import "~primevue/resources/primevue.min.css"; //core css
@import "~primeicons/primeicons.css"; //icons
@import "~primeflex/primeflex.css"; //layout
</style>
